import React, { useState, useEffect } from 'react';
import { Table } from '@quintype/em/components/table';
import { Layout, Card } from '../components/library-components';
import { TitleBar, HamburgerMenu } from '../components/accesstype';
import { CountryGroupsInspector } from '../components/country-groups/country-groups-inspector';
import { getStoryAttributeSettings, deleteStoryAttributeSettings } from '../api';

const CountryGroups = () => {
  const [activeCountryGroup, updateActiveCountryGroup] = useState({
    name: '',
    enabled: false,
    details: {},
    attribute_type: 'country'
  });
  const [countryGroups, updateAllCountryGroups] = useState([]);
  const [isInspectorActive, setInspectorState] = useState(false);
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

  useEffect(() => {
    loadCountryGroups();
  }, []);

  const loadCountryGroups = () => {
    getStoryAttributeSettings().then((storyAttributeSettings) => {
      const filteredCountryGroups = storyAttributeSettings.story_attribute_settings.filter(group => group.attribute_type === 'country');
      updateAllCountryGroups(filteredCountryGroups);
    });
  };

  const getCountryGroups = () => {
    if (countryGroups) {
      return countryGroups.map((countryGroup) => {
        const status = countryGroup.enabled ? 'Active' : 'Inactive';
        return {
          name: countryGroup.name,
          status,
          id: countryGroup.id,
          enabled: countryGroup.enabled,
          countries: countryGroup.details.countries.map((country) => regionNames.of(country))
        };
      });
    } else {
      return [];
    }
  };

  const setCountryGroupState = (row) => {
    const klass = row.original.status === 'Active' ? 'success' : 'danger';
    return <span className={klass}>{row.original.status}</span>;
  };

  const setCountries = (row) => row.original.countries.join(', ') || '';

  const inspectorToggle = () => {
    loadCountryGroups();
    closeInspector();
  };

  const closeInspector = () => setInspectorState(false);

  const onEdit = (countryGroupId) => {
    const countryGroup = countryGroups.find((group) => group.id === countryGroupId);
    updateActiveCountryGroup(countryGroup);
    setInspectorState(true);
  };

  const onDelete = (countryGroupId) => deleteStoryAttributeSettings(countryGroupId).then(() => loadCountryGroups());

  const generateRandomKey = () => Date.now();

  const usedCountryGroupNames = () => {
    const countryGroupNames = countryGroups.map(item => item.name.toLowerCase());
    return countryGroupNames.filter(item => item !== activeCountryGroup.name.toLowerCase());
  };

  const countryGroupColumns = () => ([
    {
      Header: 'Group Name',
      accessor: 'name',
      Cell: ({ row }) => (row.original.name ? row.original.name : '')
    },
    {
      Header: 'Countries',
      accessor: 'countries',
      Cell: ({ row }) => setCountries(row)
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => setCountryGroupState(row)
    },
    {
      Header: '',
      accessor: 'context-menu',
      Cell: function Hamburger ({ row }) {
        return (
          <HamburgerMenu
            item={row.original.id}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        );
      }
    }
  ]);

  return (
    <Layout>
      <TitleBar
        title="Country Groups"
        buttonText="Create"
        onActionButtonClick={() => {
          updateActiveCountryGroup({
            name: '',
            enabled: false,
            details: {},
            attribute_type: 'country'
          });
          setInspectorState(true);
        }}
      />
      <Card>
        <Table
          noDataText="No Data Available"
          isLoading={!countryGroups}
          columns={countryGroupColumns()}
          data={getCountryGroups()}
        />
      </Card>
      <CountryGroupsInspector
        key={generateRandomKey()}
        countryGroup={activeCountryGroup}
        isInspectorActive={isInspectorActive}
        actionInspector={inspectorToggle}
        onClose={closeInspector}
        usedCountryGroupNames={usedCountryGroupNames()}
      />
    </Layout>
  );
};

export default CountryGroups;
